import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space, radii } = theme

export const CarouselWrapper = styled.div`
  position: relative;
  overflow: hidden;

  .swiper {
    height: 100%;

    .swiper-pagination {
      text-align: left;
    }

    .swiper-pagination-bullet {
      width: ${space['spacing-xxs']};
      height: ${space['spacing-xxs']};
      background-color: ${colors['neutral-icon-disabled']};
      border-radius: ${space['spacing-sm']};
      cursor: pointer;
      transition: width 0.34s ease;
    }

    .swiper-pagination-bullet-active {
      width: ${space['spacing-md']};
      background-color: ${colors['cyan-background-strong-default']};

      @media (${media.tablet}) {
        width: ${space['spacing-lg']};
      }
    }

    .swiper-slide {
      height: auto;
    }

    &:not(.swiper-fade) {
      overflow: visible;
    }

    &.swiper-fade {
      .swiper-slide:not(.swiper-slide-active) {
        opacity: 0 !important;
      }
    }
  }
`

export const ControlsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${space['spacing-giga']};
`

export const SlideControls = styled.ul`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};
`

export const SlideControlItem = styled.li`
  width: ${space['spacing-xxs']};
  height: ${space['spacing-xxs']};
  background-color: ${colors['neutral-icon-disabled']};
  border-radius: ${space['spacing-sm']};
  cursor: pointer;
  transition: width 0.34s ease;

  &[data-state='active'] {
    width: ${space['spacing-md']};
    background-color: ${colors['cyan-background-strong-default']};

    @media (${media.tablet}) {
      width: ${space['spacing-lg']};
    }
  }
`

export const ArrowControls = styled.div`
  display: flex;
  gap: ${space['spacing-xxs']};

  button.ds-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    width: ${space['spacing-xl']};
    border-radius: ${radii['corner-radius-circular']};
  }
`
